import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/main/shared/shared.module';

import { ActualRainfallComponent } from './actual-rainfall.component';
import { DataService } from './utils/service/data.service';
import { MapService } from './utils/service/map.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [ActualRainfallComponent],
  exports: [ActualRainfallComponent],
  providers: [DataService, MapService]
})
export class ActualRainfallModule { }
